import { render, staticRenderFns } from "./DisplayImageId.vue?vue&type=template&id=5d338c62&scoped=true"
import script from "./DisplayImageId.vue?vue&type=script&lang=ts"
export * from "./DisplayImageId.vue?vue&type=script&lang=ts"
import style0 from "./DisplayImageId.vue?vue&type=style&index=0&id=5d338c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d338c62",
  null
  
)

export default component.exports